<template>
    <multiselect
        v-model="headquartersSelected"
        :options="headquarters.list"
        track-by="uuid"
        label="name"
        :multiple="true"
        :allowEmpty="!!allowEmpty"
        placeholder="Sede"
        selectedLabel=""
        selectLabel="+"
        deselectLabel="-"
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapState} from 'vuex';

    export default {
        name: "HeadquartersSelector",
        components: {
            Multiselect
        },
        props: {
            value: Array,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                headquartersSelected: []
            }
        },
        mounted() {
            this.$store.dispatch('loadHeadquarters');
            this.headquartersSelected = this.evaluateValue(this.value);
        },
        computed: {
            ...mapState([
                'headquarters'
            ])
        },
        methods: {
            evaluateValue(value) {
                if (Array.isArray(value)) {
                    return value;
                } else if (value && value.uuid && this.findHeadquartersByUuid(value.uuid)) {
                    return [value];
                } else {
                    return [];
                }
            },
            findHeadquartersByUuid(uuid) {
                if (!!this.headquarters) {
                    return this.headquarters.list.find(headquarters => (headquarters.uuid === uuid));
                } else {
                    return null;
                }
            },
            notifyChange(headquarters) {
                this.$emit('input', headquarters);
            }
        },
        watch: {
            value: function () {
                this.headquartersSelected = this.evaluateValue(this.value);
            },
            'headquarters.list': function () {
                this.headquartersSelected = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>